const StyleProperties = {
    BORDER_RADIUS: 'borderRadius',
    BORDER_WIDTH: 'borderWidth',
    BORDER_COLOR: 'borderColor',
    BACKGROUND_COLOR: 'backgroundColor',
    COLOR: 'color',
    COLOR_SCHEME: 'colorScheme'
};

export default StyleProperties;



// WEBPACK FOOTER //
// ./js/modules/privates/styleConstants.es6